export default __webpack_public_path__ + "static/media/allowable-medical-expenses.b5adab2e.svg";